module.exports = __webpack_public_path__ + "static/108_001-0b468384a78056ce25207aad910df663.jpg";